import { Box } from '@mui/material';
import { Assets } from '@/components/Structures';
import { DefaultLayout } from '@/layouts';
import { useRouter, useFetchCookies } from '@/hooks';
import { PageLoader } from '@/components/shared/PageLoader';
import { GlobalSnackbar } from '@/components/shared/Snackbar/GlobalSnackbar';

export const PlatformAssetsPage = () => {
  const router = useRouter();
  const { platformId } = router.query;
  const cookiesFetched = useFetchCookies();

  if (!platformId || Array.isArray(platformId)) {
    return <div>Please specify platform id</div>;
  }

  if (!cookiesFetched) {
    return (
      <Box sx={{ position: 'relative', top: '25rem' }}>
        <PageLoader />
      </Box>
    );
  }
  return (
    <DefaultLayout>
      <Assets />
      <GlobalSnackbar />
    </DefaultLayout>
  );
};
